import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";

import { Form, ObservationImages, Constant } from "../../constants";
import { CustomizedAppBar } from "../../components";
import "./style.css";
import { useTranslation } from 'react-i18next';

const FormOptionPage = () => {
    const { t: translate } = useTranslation();
    const { state } = useLocation()
    const navigate = useNavigate()

    const [materialIcon, setMaterialIcon] = useState('')
    const [reportType, setReportType] = useState([])

    const renderOperation = () => {
        const form = Form.getForm();
        const keys = Object.keys(form);
        let operationParameter = []
        let icon = ""
        keys.forEach(key => {
            const formParameter = form[key]["_parametres_"]
            if (state.formName === formParameter.bouton_materiel) {
                icon = formParameter.icone_url.slice(1, formParameter.icone_url.length)
                operationParameter.push(<div className="pointer report-list-item" key={formParameter.id} onClick={() => selectOperation(formParameter.id)}>
                    <p>&#9658; {formParameter.nom}</p>
                </div>)
            }
        })

        setMaterialIcon(icon)
        setReportType(operationParameter)
    }

    const selectOperation = (id) => {
        localStorage.setItem(Constant.localStorageKey.formId, id)
        ObservationImages.reset()
        navigate("/operation", { state: { formName: state.formName, prev: true } })
    }

    const backToMaterialPage = () => {
        window.history.go(-1)
    }

    useEffect(() => {
        renderOperation()

        const popStateHandler = () => {
            const currentHistory = window.history.length
            window.history.go(-currentHistory + 1)
        }

        window.onpopstate = popStateHandler;
    }, [])


    return <div className={`page ${state && state.prev ? "page--prev" : ""}`}>
        <CustomizedAppBar title={translate("changeMaterial")} onBackButtonClick={backToMaterialPage} />
        <div className="form-group">
            <h1>{translate('enterReportTitle')}</h1>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12} md={12} lg={2}>
                    <div style={{ width: "fit-content", margin: "auto" }}>
                        <img src={"https://hydrotest2.frckb.net/_test_beta" + materialIcon} />
                    </div>
                </Grid>
                <Grid item xs={12} md={12} lg={8}>
                    {reportType}
                </Grid>
            </Grid>
            <p style={{ visibility: "hidden" }}>p</p>
        </div>
    </div>
}

export default FormOptionPage;